<template>
  <div>
    <main-layout />
    <audio ref="audio" :src="activeSound" preload id="audio" muted></audio>
  </div>
</template>

<script>
import MainLayout from "./layouts/MainLayout.vue";
import config from "./config";

export default {
  name: "App",
  components: {
    MainLayout,
  },
  data: () => ({
    activeSound: null,
  }),
  created() {
    // The theme store reads "theme" when the app boots, so the very first visit has to reload once.
    if (localStorage.getItem("theme") == null) {
      localStorage.setItem("theme", JSON.stringify(config));
      window.location.reload();
    }
    localStorage.setItem("theme", JSON.stringify(config));
  },
};
</script>
